import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

interface ISendInventoryData {
  recipients: string[];
  search?: string;
  sort?: string;
  soldFilter?: string;
  videosRecordedFilter?: string;
  countRecorded?: boolean;
}

const sendInventory = async (data: ISendInventoryData) => {
  return (await EXPRESS_API.post('/inventory/send', data)).data;
};

interface ISendInventoryParams {
  onSuccess?: () => void;
}

export const useSendInventoryMutation = ({
  onSuccess,
}: ISendInventoryParams) => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(sendInventory, {
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
      successToast({
        title: t(
          'Inventory Report is being processed and will be sent shortly.'
        ),
      });
    },
    onError: () => {
      showError(t('There was an issue sending your report. Please try again.'));
    },
  });
};
